import {
  Component,
  Host,
  h,
  ComponentInterface,
  Prop,
  State,
  Element,
  Event,
  EventEmitter,
  Watch,
} from '@stencil/core';
import ResizeObserver from 'resize-observer-polyfill';
import { Maybe, LayoutSize } from '../../../global/types';
import { COMPONENT_SMALL_SIZE_CLASS } from '../../../global/constants';

@Component({
  tag: 'rt-resize-watcher',
  styleUrl: 'resize-watcher.css',
  shadow: true,
})
export class ResizeWatcher implements ComponentInterface {
  @Prop() breakpoint = 719;

  @Element() el: HTMLElement;

  @Event()
    breakPointChanged: EventEmitter;

  @State() width: Maybe<number>;

  @State() size: Maybe<LayoutSize>;

  @Watch('size')
  handleSizeChange(value: LayoutSize) {
    this.breakPointChanged.emit(value);
  }

  private ro: ResizeObserver;

  connectedCallback() {
    this.ro = new ResizeObserver(([entries] = []) => {
      const contentRect = entries?.contentRect || null;
      if (contentRect) {
        this.width = contentRect.width;
        this.size = this.width <= this.breakpoint ? LayoutSize.SMALL : LayoutSize.DEFAULT;
      }
    });
    this.ro.observe(this.el);
  }

  disconnectedCallback() {
    this.ro.unobserve(this.el);
  }

  render() {
    const sizeClass = this.width <= this.breakpoint ? COMPONENT_SMALL_SIZE_CLASS : '';
    return (
      <Host class={sizeClass}>
        <slot></slot>
      </Host>
    );
  }
}
